import { LudsModal } from '../typings';
export class ModalService {
  private static instance: ModalService;
  private dialog: LudsModal;

  private constructor() {
    document.addEventListener('luds-dialog-close', () => {
      if (this.dialog) {
        document.body.removeChild(this.dialog);
      }
    });
  }

  async openModal(content: string, options: Partial<LudsModal> = {}): Promise<void> {
    await import('../design-system/modal/modal');

    this.dialog = document.createElement('luds-modal') as LudsModal;

    // Add a class to the modal to ensure:
    // - Body scrolling is prevented when the modal is open
    // - Clicking on other content is disabled while the modal is open
    // - The modal remains centered on the screen
    this.dialog.className = 'luds-modal-fixed';

    // Manually assigning slots, needed for rendering slot content.
    const slotPlaceholder = document.createElement('div');
    slotPlaceholder.innerHTML = content;
    const slots = Array.from(slotPlaceholder.children);

    slots.forEach((slot) => {
      this.dialog.appendChild(slot);
    });

    // Set properties based on options
    Object.assign(this.dialog, options);

    document.body.appendChild(this.dialog);

    this.dialog.open = true;
  }

  public static getInstance(): ModalService {
    if (!ModalService.instance) {
      ModalService.instance = new ModalService();
    }

    return ModalService.instance;
  }
}
